import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';

// TODO rename this component
// TODO move EmailVerificationComponent to folder near this one
@Component({
  selector: 'app-email-verify',
  styleUrls: ['./email-verify.component.scss'],
  templateUrl: './email-verify.component.html',
})
export class EmailVerifyComponent implements OnInit {
  public isSuccessful = false;
  public errorMessage: string;

  constructor(private httpClient: HttpClient) {}

  public ngOnInit(): void {
    this.httpClient.get(`${environment.backendApiUrl}/v1/users/email/verification_token`)
      .subscribe({
        next: () => {
          this.isSuccessful = true;
        },
        error: (err) => {
          this.isSuccessful = false;
          this.errorMessage = err.error.message;
        }
      });
  }
}
